import type { PassViewRecord } from '../../../utils/fetchWeldViewApis';
import type { WpsViolationRecord } from '../../../utils/wpsViolationModel';
import type { PipeOption } from '../../../../ndt/components/FilterPanel';
import type { NdtIndicationRow, WeldDrillDownRow } from './drillDownTypes';
import { WeldDrillDownDetail } from './WeldDrillDownDetail';

interface WeldDrillDownRightPanelProps {
  selectedRow: WeldDrillDownRow | null;
  statusCalculationMethod: string;
  ndtLogs: NdtIndicationRow[];
  ndtLoading?: boolean;
  ndtError?: string | null;
  onEditNdt?: () => void;
  canEditNdt?: boolean;
  welderIds?: string;
  passesLoading?: boolean;
  passRecords?: PassViewRecord[];
  wpsViolations?: WpsViolationRecord[];
  wpsViolationsLoading?: boolean;
  showWpsViolationDetail?: boolean;
  limitsConfigured?: boolean;
  pipeId?: string | null;
  pipeOptions?: PipeOption[];
  dashboardProjectId?: number | null;
}

export const WeldDrillDownRightPanel = ({
  selectedRow,
  statusCalculationMethod,
  ndtLogs,
  ndtLoading,
  ndtError,
  onEditNdt,
  canEditNdt = false,
  welderIds = '—',
  passesLoading = false,
  passRecords = [],
  wpsViolations = [],
  wpsViolationsLoading = false,
  showWpsViolationDetail = false,
  limitsConfigured = true,
  pipeId = null,
  pipeOptions = [],
  dashboardProjectId = null,
}: WeldDrillDownRightPanelProps) => (
  <div className="flex min-h-0 flex-1 flex-col">
    {selectedRow ? (
      <WeldDrillDownDetail
        row={selectedRow}
        statusCalculationMethod={statusCalculationMethod}
        ndtLogs={ndtLogs}
        ndtLoading={ndtLoading}
        ndtError={ndtError}
        canEditNdt={canEditNdt}
        onEditNdt={onEditNdt}
        welderIds={welderIds}
        passesLoading={passesLoading}
        passRecords={passRecords}
        wpsViolations={wpsViolations}
        wpsViolationsLoading={wpsViolationsLoading}
        showWpsViolationDetail={showWpsViolationDetail}
        limitsConfigured={limitsConfigured}
        pipeId={pipeId}
        pipeOptions={pipeOptions}
        dashboardProjectId={dashboardProjectId}
      />
    ) : (
      <div className="flex h-full min-h-[200px] flex-1 items-center justify-center rounded-xl border border-dashed border-[#E2E5EA] bg-white/60 p-6">
        <p className="text-center text-sm text-heritage-grey">
          Select a weld in the table to view WPS violation detail and production context.
        </p>
      </div>
    )}
  </div>
);
